import { call, put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';

type UserInitResponse = {
  headline: string,
  name: string,
  profileImage: {
    _id: string,
    sources: {
      cropped: {
        url: string
      }
    }
  },
}

export function* getUserInit(): Generator<any, void, empty> {
  try {
    const response: UserInitResponse = yield call(() => APIService.apiRequest('GET_USER_INIT', 'GET'));

    yield put({
      type: ActionTypes.user.init.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.user.init.ERROR,
      error,
    });
  }
}

export function* getUserInfo(action): Generator<any, void, empty> {
  const userId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('GET_USER_INFO', 'GET', {
      routeParams: {
        id: userId,
      },
    }));

    yield put({
      type: ActionTypes.user.getInfo.SUCCESS,
      id: userId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.user.getInfo.ERROR,
      error,
    });
  }
}

export function* patchUserInfo(action): Generator<any, void, empty> {
  const userId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_USER_INFO', 'PATCH', {
      routeParams: {
        id: userId,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.user.patch.SUCCESS,
      id: userId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.user.patch.ERROR,
      error,
    });
  }
}
